import { render, staticRenderFns } from "./slider-min-max.mpx?vue&type=template&id=6865e225&isComponent&outputPath=components%2Fslider-min-max5ce29654%2Findex"
import script from "./slider-min-max.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-min-max5ce29654%2Findex"
export * from "./slider-min-max.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-min-max5ce29654%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports